import { createSelector, createFeatureSelector } from '@ngrx/store';
import { FormsDataState } from './forms-data.state';

export const selectFormsDataState =
  createFeatureSelector<FormsDataState>('formsData');

export const selectShippingCourierFormData = createSelector(
  selectFormsDataState,
  (state: FormsDataState) => state.shippingCourierFormData
);

export const selectShippingPointFormData = createSelector(
  selectFormsDataState,
  (state: FormsDataState) => state.shippingPointFormData
);

export const selectDeliveryCourierFormData = createSelector(
  selectFormsDataState,
  (state: FormsDataState) => state.deliveryCourierFormData
);

export const selectDeliveryPointFormData = createSelector(
  selectFormsDataState,
  (state: FormsDataState) => state.deliveryPointFormData
);

export const selectShipmentFormData = createSelector(
  selectFormsDataState,
  (state: FormsDataState) => state.shipmentFormData
);

export const selectConfirmFormData = createSelector(
  selectFormsDataState,
  (state: FormsDataState) => state.confirmFormData
);

export const selectSelectedPartners = createSelector(
  selectFormsDataState,
  (state: FormsDataState) => state.selectedPartners
);
